import { createApp, defineAsyncComponent } from 'vue';
import { initSentryVue } from './sentry';
import { $ } from './utils';

export const initJobPostingsLocationSelectorApp = () => {
    const selectorEl = $('#job-postings-location-selector');
    if (!selectorEl) {
        return;
    }

    const JobPostingsLocationSelector = defineAsyncComponent(() =>
        import('../components/job-postings/JobPostingsLocationSelector.vue'),
    );
    const cities = selectorEl?.dataset?.cities ? JSON.parse(selectorEl.dataset.cities) : [];
    const label = selectorEl?.dataset?.label || 'Location';
    const placeholder = selectorEl?.dataset?.placeholder || 'Select your city';

    const app = createApp(JobPostingsLocationSelector, {
        cities,
        label,
        placeholder,
    });
    app.mount('#job-postings-location-selector');
    initSentryVue(app);
};
